import API from "../../api/api";
import { authHeader } from "../../helpers/authHeader";
const state = () => ({
  dataProtectionObj: null,
  loading: false,
});

const mutations = {
  getDataProtectionDetail(state, payload) {
    state.dataProtectionObj = payload;
  },
  addDataProtection(state, payload) {
    state.dataProtectionObj = payload;
  },
  editDataProtection(state, payload) {
    // const index = state.models.findIndex((m) => m.id === payload.id);
    // if (index) {
    state.dataProtectionObj = payload;
    // }
  },
  setDetailInput: (state, e) => {
    let dataProtectionObj = state.dataProtectionObj;
    dataProtectionObj[e.target.name] = e.target.value;
    state.dataProtectionObj = dataProtectionObj;
  },
  isLoading(state, payload) {
    state.loading = payload;
  },
};

const actions = {
  async fetchDataProtectionDetail({ commit }, payload) {
    commit("isLoading", true);
    await API.get(`data-protection/${payload}`)
      .then(res => {
        commit("getDataProtectionDetail", res.data.data);
        commit("isLoading", false);
      })
      .catch(err => {
        console.log("ERROR", err);
        commit("isLoading", false);
      });
  },
  async post({ commit }, payload) {
    await API.post("data-protection", payload, {
      headers: authHeader(),
    })
      .then(res => {
        commit("addDataProtection", res.data.data);
      })
      .catch(err => {
        console.log("ERROR", err);
      });
  },
  async put({ commit }, payload) {
    await API.put(`data-protection/1`, payload, {
      headers: authHeader(),
    })
      .then(res => {
        if (res) {
          commit("editDataProtection", res.data.data);
        }
      })
      .catch(err => {
        console.log("ERROR", err);
      });
  },
  updateInput({ commit }, e) {
    commit("setDetailInput", e);
  },
};

const getters = {
  dataProtectionObj: state => state.dataProtectionObj,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
